import { PasswordVerificationRequest } from './passwordVerificationRequest';

export class UpdateTwoFactorU2fDeleteRequest extends PasswordVerificationRequest {
    id: number;
}
